<div class="dialog-fade-overlay" *ngIf="visible">
    <div class="dialog-{{size}}" cdkTrapFocus role="dialog"  aria-modal="true" aria-labelledby="modal-aria-label">
        <div class="dialog-{{size}}__content">
            <div class="dialog-{{size}}__wrapper">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>
